import { apiClient } from "./apiClient";

export const userApi = {
  getUser: (options = {}) => {
    return apiClient.get(`${process.env.REACT_APP_USER_PATH}/me`, options);
  },
};
